import { render, staticRenderFns } from "./GlobalConfirmDialog.vue?vue&type=template&id=aeb4c3dc&scoped=true&"
import script from "./GlobalConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./GlobalConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb4c3dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
